import styled, { css } from 'styled-components';

import { RELINKING_VARIANTS } from '../../constants';
import type { RelinkingBlockVariant } from '../../types';

export const Card = styled.div<{
  $isMobile: boolean;
  $variant: RelinkingBlockVariant;
}>`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  margin-right: 8px;
  margin-bottom: 40px;

  border-radius: 4px;

  width: ${({ $variant, $isMobile }) =>
    ($variant === RELINKING_VARIANTS.HOTELS && ($isMobile ? 180 : 240)) ||
    ($variant === RELINKING_VARIANTS.COUNTRIES_WITH_PRICES &&
      ($isMobile ? 240 : 268)) ||
    240}px;

  min-height: ${({ $variant, $isMobile }) =>
    ($variant === RELINKING_VARIANTS.DEFAULT_COUNTRIES &&
      ($isMobile ? 320 : 290)) ||
    ($variant === RELINKING_VARIANTS.METAREGIONS && ($isMobile ? 310 : 210)) ||
    ($variant === RELINKING_VARIANTS.HOTELS && 214) ||
    0}px;

  ${({ $variant }) =>
    ($variant === RELINKING_VARIANTS.HOTELS && hotelsRelinkingStyles) ||
    ($variant === RELINKING_VARIANTS.COUNTRIES_WITH_PRICES &&
      newYearCountriesRelinkingStyles)}

  ${({ $variant }) => $variant !== RELINKING_VARIANTS.NARRATIVE && shadowStyles}

  ${({ $isMobile }) => !$isMobile && desktopStyles}
`;

const shadowStyles = css`
  box-shadow: rgba(210, 208, 197, 0.9) 0px 1px 2px,
    rgba(216, 214, 204, 0.9) 0px 10px 15px;
`;

const hotelsRelinkingStyles = css<{ $isMobile: boolean }>`
  height: 100%;
  ${({ $isMobile }) => $isMobile && `margin-bottom: 20px;`}
`;

const newYearCountriesRelinkingStyles = css<{ $isMobile: boolean }>`
  height: ${({ $isMobile }) => ($isMobile ? 310 : 280)}px;
`;

const desktopStyles = css`
  &:first-child {
    margin-left: 30px;
  }

  &:last-child {
    margin-right: 30px;
  }
`;
